import { Region } from '../region';
import { IPaymentProvider } from '../../providers/payment/payment.interface'
import { PaymentProviderCyberSource } from '../../providers/payment/payment.cybersource';
import { DirectBankBrand } from '../../model/types/payment-method-type';

/**
 * @description Geographical region the application is currently configured for, e.g. US, Spain, Australia.
 * @region Enumeration for this region.
 * @defaultCountryFrom Default value to use for send-from country, i.e. in price calculator
 * @defaultCurrencyFrom Default value to use for send-from currency, i.e. in price calculator
 * @defaultLanguage Default language culture to use, i.e. content translations
 */
export const regionValues = {
  region: Region.PR,
  regionId: 11711,
  defaultCountryFrom: 'PR',
  defaultCountryFromOnfido: 'PRI',
  defaultCountryCodeFrom: 1,
  defaultCurrencyFrom: 'USD',
  defaultLanguageCulture: 'es-PR',
  defaultLocation: {
    latitude: 18.404273,
    longitude: -66.071086
  },
  dateFormat: 'DD/MM/YYYY',
  postalCodeRegex:`^(\\d{5}$|\\d{5}(-\\d{4})?)$`, // TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  links: {
    linkFaq: 'https://www.riamoneytransfer.com/us/en/mobile-content/faqs'
  },
  languageCultures: ['es-PR', 'en-PR'],
  regionalIp: '66.82.123.234',
  paymentProvider: <IPaymentProvider>new PaymentProviderCyberSource(),
  isPlaidEnabled: true,
  isBankAccountEnabled:true,
  useSecurityQuestions: true,
  oldRemittanceLogin: false,
  onfidoMaxAttempts: 0,
  directBankBrand: DirectBankBrand.None,
  distanceMetric: 'km',
  acceptInternationalCards:false,
  stagedRiaBrand: '',
  payNearMeBrand: '',
  isEu: false,
  isEMEA: false,
  notShowMarketingPushAlert: true,
  useVeriff: false,
  googlepayAdyenPaymentNetworks: ["masterCard", "visa"],
  applepayAdyenPaymentNetworks: ["masterCard", "visa"],
  adyenMerchantCapability: ["debit", "3ds", "credit"],
  walletSettings:{
    isMerchantSupportEnable:false,
  },
  defaultTranslationParams: null,
  originalCountryAllowedOnly: false,
  canShowLogosOnQRScanner: false,
  airtimeServices:{
    isAirTimeSevice:false,
    isLocalOnly:false,
  },
  passCodeLength: 6,
  walletServices:[],
  isCountrySupportDecimal: true,
  showNewHomePage: true,
  autoEnableMarketingPreference: false,
  loginRootHomePage: "activity",
  adyenRegion: 'live-us'// https://docs.adyen.com/development-resources/live-endpoints/#client-side-environment-region
};



// WEBPACK FOOTER //
// ./src/environment/region/PR.ts